module.exports = __webpack_public_path__ + "img/Insta.2d1695d.png";